import React, { useState } from "react";
import ProgressBarContext from "./ProgressBarContext";

const ProgressBarState = (props) => {

  const [progressObjs, setProgressObjs] = useState([]);
  let [progressBarId, setProgressBarId] = useState(0);

//   const updateProgressObj =  (index, newProgressObj) => {
//     setProgressObjs((prevProgressObjs) => {
//         const updatedProgressObjs = [...prevProgressObjs];
//         updatedProgressObjs[index] = newProgressObj;
//         return updatedProgressObjs;
//     });
// };
  // let progressBarId = 0;

  const updateProgressObj = (newProgressObj) => {
    setProgressObjs((prevProgressObjs) => {
      return [...prevProgressObjs, newProgressObj];
    });
    console.log(newProgressObj);
    console.log(progressObjs);
  };
  return (
    <ProgressBarContext.Provider
      value={{
        progressObjs,
        setProgressObjs,
        progressBarId,
        setProgressBarId,
        updateProgressObj
      }}
    >
      {props.children}
    </ProgressBarContext.Provider>
  );
};

export default ProgressBarState;
